export const
    TRAILS_PENDING = 'trails_pending',
    TRAILS_FAILED = 'trails_failed',
    TRAILS_DOWNLOADED = 'trails_downloaded',
    TRAILS_RESET = 'trails_reset',
    TRAIL_RESET = 'trail_reset',
    TRAIL_FOCUS = 'trail_focus',
    TRAIL_DOWNLOADED = 'trail_downloaded',
    TRAIL_FAILED = 'trail_failed',
    TRAIL_DELETING = 'trail_deleting',
    TRAIL_DELETED = 'trail_deleted',
    TRAIL_POSTING = 'trail_posting',
    TRAIL_EDITING = 'trail_editing',
    TRAIL_MEDIA_FOCUS = 'trail_media_focus',
    TRAIL_MEDIA_UPLOADING = 'trail_media_posting',
    TRAIL_MEDIA_FAILED = 'trail_media_failed',
    TRAIL_MEDIA_UPLOADED = 'trail_media_uploaded',
    TRAIL_MEDIA_DELETING = 'trail_media_deleting',
    TRAIL_MEDIA_DELETED = 'trail_media_deleted';



// WEBPACK FOOTER //
// src/store/trails/types.js